export const TEST_ID_EMAIL_LINK_CONTAINER = 'TEST_ID_EMAIL_LINK_CONTAINER';
export const TEST_ID_EMAIL_LINK_TITLE_CONTAINER =
  'TEST_ID_EMAIL_LINK_TITLE_CONTAINER';
